import React, { FC } from "react";
import { RenderFormFields } from "src/components/RenderFormFields";
import { StepControls } from "../StepControls";
import { COMPANY_NAME_ADDRESS_SITE_FIELDS } from "../constants/fields";
import { useTranslation } from "react-i18next";
import { registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const CompanyInfo: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <h2 className="font-semibold">
          {t(registrationTitlesTrns.companyInfo)}
        </h2>

        <div className="flex flex-col justify-center items-center flex-1 gap-5 lg:gap-3 lg:flex-row">
          <RenderFormFields fields={COMPANY_NAME_ADDRESS_SITE_FIELDS} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
